module.exports = __webpack_public_path__ + "static/media/battery-2.aa5a6326.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/battery-2.svg
// module id = 2395
// module chunks = 7